import { AppState } from '../../root-reducer';

export const selectActiveAnimatedLayer = (state: AppState) => state.animatedLayerDomain.activeAnimatedLayer;
export const selectAnimatedLayers = (state: AppState) => state.animatedLayerDomain.animatedLayers;